import { createSelector } from 'reselect'
import type { RootState } from 'shared/store/reducers'
import { filterKingdomPointsCoupons } from 'shared/utils'

export const kingdomCouponsSelector = createSelector(
    (state: RootState) => state.kingdomPrivilegesPageState?.coupons,
    coupons => filterKingdomPointsCoupons(coupons)
)
